<template>
    <div
        class="document form-row align-items-center with-border border-bottom py-2"
        :class="singleDocument.Status === 'complete' ? 'new' : null"
    >
        <div class="col-2 d-flex align-items-center">
            <div class="single-downloaded-indicator">
                <span class="single-downloaded-indicator-icon"></span>
            </div>
            <img
                class="file-type-icon"
                :src="fileTypeIconSrc"
                :alt="`${singleDocument.Type} icon`"
            />
        </div>
        <div class="col-8 tighten-light-height">
            <div class="name-and-progress">
                <div class="file-name">
                    {{
                        `${singleDocument.DocumentName}.${singleDocument.Type}`
                    }}
                </div>
            </div>
            <div
                class="
                    bg-success
                    progress-bar-striped progress-bar-animated
                    active
                "
                :class="singleDocument.Status === 'pending' ? 'progress' : null"
            >
                <div class="bar" style="width: 100%"></div>
            </div>

            <div v-show="errorExists" class="error_message limited-font-size">
                Error. Please try again.
            </div>
            <div
                v-if="singleDocument.Status !== 'complete'"
                class="text-left limited-font-size text-capitalize"
            >
                {{ singleDocument.Status }}
            </div>
            <div v-else class="text-left">
                <a
                    :href="`/background_documents/${singleDocument.Id}/download`"
                    target="_blank"
                    class="limited-font-size"
                    @click="removeDownloadedDocument"
                >
                    Download
                </a>
            </div>
        </div>
        <div class="col-2">
            <button
                type="button"
                class="btn btn-link limited-font-size p-0 font-weight-normal"
                @click="removeCanceledDocument"
            >
                {{ cancelLinkText }}
            </button>
        </div>
    </div>
</template>

<script>
import CSVIconSrc from 'images/csv_icon.svg';
import PDFIconSrc from 'images/pdf_icon.svg';
export default {
    props: {
        singleDocument: {
            type: Object,
            default: function() {
                return {};
            }
        },
    },
    data() {
        return {
            errorExists: false,
        };
    },
    computed: {
        fileTypeIconSrc: function() {
            if (this.singleDocument.Type === 'pdf') {
                return PDFIconSrc;
            }
            return CSVIconSrc;
        },
        cancelLinkText: function() {
            if (this.singleDocument.Status === 'complete') {
                return 'clear';
            }
            return 'cancel';
        },
    },
    methods: {
        removeDownloadedDocument: function() {
            setTimeout(() => {
                this.$emit('removeDownloadedDocument');
            }, 100);
        },
        removeCanceledDocument: function() {
            this.$emit('removeCanceledDocument');
        }
    },
};
</script>

<style lang="scss" scoped>
    .limited-font-size {
        font-size: 0.85rem;
    }
    .file-type-icon {
        height: 35px;
        width: auto;
    }
    .single-downloaded-indicator {
        width: 12px;
        height: 12px;
        background: none;
        border-radius: 24px;
        display: block;
    }
    .single-downloaded-indicator-icon {
        width: 10px;
        height: 10px;
        background: none;
        border-radius: 24px;
        display: block;
    }
    .new {
        .file-name {
            font-weight: bold;
        }
        .single-downloaded-indicator-icon {
            background: #60bf5f;
        }
    }
    .name-and-progress {
        text-align: left;
        .file-name {
            display: block;
            margin-bottom: 2px;
            font-size: 13px;
        }
        & > a {
            display: none;
        }
    }
    .tighten-light-height {
        line-height: 1;
    }
</style>
